module.exports = __webpack_public_path__ + "static/media/aauxnext-rg.6e4adbfd.woff2";